import React from "react";
import FlashCardForm from "./FlashcardForm";

const CreateFlashcards = () => {

    return (
        <div align="center" style={{marginTop: "120px"}}>
            <FlashCardForm/>
        </div>
    )
}

export default CreateFlashcards